import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/ui/accordion'
import { cn } from '@/lib/utils'

const FcaTimelineItem = ({ item, isFirst, isLast }) => (
  <AccordionItem value={item.id} className="border-b-0">
    <div className="flex gap-3">
      <div
        className="relative flex w-3 flex-none justify-center"
        aria-hidden="true"
      >
        {!isFirst && <span className="absolute top-0 h-2 w-px bg-black" />}
        <span className="relative top-2 h-2.5 w-2.5 shrink-0 rounded-full bg-black" />
        {!isLast && <span className="absolute top-2 bottom-0 w-px bg-black" />}
      </div>
      <div className={cn('min-w-0 flex-1', isLast ? 'pb-0' : 'pb-5')}>
        <AccordionTrigger className="rounded-md py-0 hover:no-underline">
          <span className="flex flex-col text-left">
            <span className="self-start px-2 py-0.5 text-xs font-semibold tracking-wide text-[#ff914d] uppercase">
              {item.date}
            </span>
            <span className="text-foreground font-semibold">
              {item.headline}
            </span>
          </span>
        </AccordionTrigger>
        <AccordionContent>
          <p className="text-foreground mb-3 text-sm leading-relaxed sm:text-base">
            {item.description}
          </p>
          <ul className="space-y-2">
            {item.links.map(link => (
              <li key={link.url}>
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-foreground text-sm font-semibold break-words text-[#FF914D] underline underline-offset-2"
                >
                  {link.label} (opens in a new tab)
                </a>
              </li>
            ))}
          </ul>
        </AccordionContent>
      </div>
    </div>
  </AccordionItem>
)

export default FcaTimelineItem
